export const APP_MODES = {
    PUBLIC_DIRECT: 'public_direct',
    ACCOUNT_DIRECT: 'account_direct',
} as const;
